/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'

import { WidgetGuard } from 'features/types'
import { TopicNotSelectedGuard } from '../../../../share/guards'
import MeasureTypesAndMetricNamesEmptyGuard from './MeasureTypesAndMetricNamesEmptyGuard'

const WidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <MeasureTypesAndMetricNamesEmptyGuard widgetId={widgetId}>
      {children}
    </MeasureTypesAndMetricNamesEmptyGuard>
  </TopicNotSelectedGuard>
)

export default WidgetSettingGuards
